module.exports = __webpack_public_path__ + "img/logo-wall@2x.f8c5c174.png";